import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DropDownSelect from '../../../../src/components/DropDownSelect/index';
import DropDownSearch from '../../../../src/components/DropDownSearch';
import DropDownScroll from '../../../../src/components/DropDownScroll/index';
import {
  useGetAssignmentCoursesMutation, 
  useGetAssignmentStudentsListMutation,
  useGetAssignmentClassesMutation,
} from '../../../features/authentication/reportApiSlice';
import { Col, Row } from 'react-bootstrap';
import CustomToast from '../../../components/Toast';
import { useReportContext } from './reportContext';
import SkeletonGrid from '../../../components/SkeletonLoader/SkeletonGrid';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ReportFilter = ({
  handleCreateReport,
  isTOTReport,
  title,
  description,
  type
}) => {
  let takeSize = 30;
  const [getAssignmentsAndCourses] = useGetAssignmentCoursesMutation();
  const [getAssignmentStudents] = useGetAssignmentStudentsListMutation();
  const [getAssignmentClasses] = useGetAssignmentClassesMutation();
  const reportType = window.location.href.split('/').pop();

  const { selectedStudentId, setSelectedStudentId, studentName, setStudentName, selectedClassIds, setSelectedClassIds, setSelectedClassId, selectedClassId,
    assignmentId, setAssignmentId, includeRetakes, setIncludeRetakes, startDate, setStartDate, endDate, setEndDate,
    isAllReport, setIsAllReport, studentToIncludeTab, setStudentToIncludeTab, selectedCourseId, setSelectedCourseId, className,
    setClassName, courseName, setCourseName, isAssessment, scoreTypeTab, setScoreTypeTab } = useReportContext();

  const [selectedAssignmentName, setSelectedAssignmentName] = useState('');
  const [searchString, setSearchString] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchString);
  const [isLoading, setIsLoading] = useState(false);
  const [initial, setInitial] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [skip, setSkip] = useState(0);
  const [courses, setCourses] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [allAssignments, setAllAssignments] = useState([]);
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [dateBasedKey, setDateBasedKey] = React.useState(new Date().getTime().toString());

  useEffect(() => {
    if(selectedStudentId > 0 && students.length > 0)
    {
      var student = students.filter(x=>x.id == selectedStudentId);
      if(student?.length==1)
        setStudentName(student[0].name);
    }
  }, [selectedStudentId]);

  const applySelectedCourseName = (courses) =>{
    if(courses && courses.length>0)
    {
      const course = courses.find(x=>x.id == selectedCourseId);
      if(course)
        setCourseName(course.name);
      else
      {
        setCourseName(courses[0].name);
        setSelectedCourseId(courses[0].id);
      }
    }
  };

  const applyAssignmentName = (assignments) => {
    var resultAssignments = assignments.filter((item) => item.courseId == selectedCourseId);
    if (resultAssignments?.length > 0) {
      if(isTOTReport)
      {
        resultAssignments = resultAssignments.map((item) =>  ({id: item.id , name : (item.isAssessment? 'Assessment - ' : 'Assignment - ') + item.name}));
      }
      setAssignments(resultAssignments);
      const assignment = resultAssignments.find(item=>item.id == assignmentId);
      if(assignment){
        setSelectedAssignmentName(assignment.name);
      }
      else{
        setAssignmentId(resultAssignments[0].id);
        setSelectedAssignmentName(resultAssignments[0].name);
      }
    }
    else {
      setAssignments([]);
      setAssignmentId(0);
      setSelectedAssignmentName('');
    }
  };

  useEffect(() => {
    if (selectedCourseId >= 0) {
      if(!initial){
        applySelectedCourseName(courses);
      }
      else{
        getReportFilterData();
        setInitial(false);
      }
    }
  }, [selectedCourseId]);

  useEffect(() => {
    if (allAssignments?.length > 0 && selectedCourseId >= 0) {
      applyAssignmentName(allAssignments);
    }
  }, [allAssignments,selectedCourseId]);

  const getReportFilterData = async () => {
    setIsPageLoading(true);
    const option={
      isAssessment : isAssessment,
      getOnlyTimeOnTask: isTOTReport,
      isLoginReport:false
    };
    var response = await getAssignmentsAndCourses(option).unwrap();
    setCourses(response.courses);
    setAllAssignments(response.assignments);
    applySelectedCourseName(response.courses);
    setIsPageLoading(false);
  };

  useEffect(() => {
    if (assignmentId > 0) {
      setClasses([]);
      setSearchString('');
      setStudents([]);
      if(!isAllReport && !initial)
      { 
        setSelectedStudentId(0);
        setStudentName('');
      }
      setDateBasedKey(new Date().getTime().toString());
      if (studentToIncludeTab == 2) {
        getAssignmentStudentsAsync((reportType == 'single-admin-assessment' || reportType == 'single-assignment' || !isAllReport) ? assignmentId : -1, 0, takeSize, true, []);
      }
      else if (studentToIncludeTab == 1) {
        getAssignmentClassesAsync((reportType == 'single-admin-assessment' || reportType == 'single-assignment' || !isAllReport) ? assignmentId : -1);
      }
    }
  }, [assignmentId]);

  useEffect(() => {
    if (!initial) {
      const handler = setTimeout(() => {
        setSearchString(debouncedSearchText);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [debouncedSearchText]);

  useEffect(() => {
    if (!initial) {
      getAssignmentStudentsAsync((reportType == 'single-admin-assessment' || reportType == 'single-assignment' || !isAllReport) ? assignmentId : -1, 0, takeSize, true, []);
    }
  }, [searchString]);

  const getAssignmentStudentsAsync = async (assignmentId, skip, take, hasMore, students) => {

    if (hasMore) {
      setIsLoading(true);
      const options = {
        assignmentId: assignmentId,
        skip: skip,
        take: take,
        isAssessment: isAssessment,
        getOnlyTimeOnTask: isTOTReport,
        searchString: searchString,
        isLoginReport: false
      };
      var response = await getAssignmentStudents(options).unwrap();
      setHasMore((skip + take) < response.total);
      if (response.data?.length > 0){
        var newStudents = [...students,...response.data];
        setStudents(newStudents);
        if(selectedStudentId>0)
        {
          var student = newStudents.find(x=>x.id==selectedStudentId);
          if(student)
          {
            setStudentName(student.name);
            setSelectedStudentId(student.id);
          }
        }
      }
      else{
        const noResults = [{ id: -2, name: 'No results found' }];
        setStudents(noResults);
        setSelectedStudentId(0);
        setStudentName('');
      }
      setIsLoading(false);
    }
  };

  const getAssignmentClassesAsync = async (assignmentId) => {
    const options = {
      assignmentId: assignmentId,
      isAssessment: isAssessment,
      getOnlyTimeOnTask: isTOTReport,
      isLoginReport: false
    };
    let classArray = await getAssignmentClasses(options).unwrap();
    if(!isAllReport){
      const obj = {
        id: -1,
        name: 'All Classes'
      };
      classArray = [obj, ...classArray];
      setClasses(classArray);
      const selectedClass = classArray.find(x=> x.id == selectedClassId);
      if(selectedClass)
        setClassName(selectedClass.name);
    }
    else {
      selectAllClasses(classArray);
    }
  };

  const selectAllClasses = (classes) => {
    const updatedClassList = classes.map((item) => ({
      ...item,
      isChecked: true
    }));
    const ids = updatedClassList.map((item) => item.id);
    setSelectedClassIds(ids);
    setClasses(updatedClassList);
  };

  const handleClassSelectionChange = (e) => {
    const { key } = e;
    const selected = key !== '000' ? classes.find((v) => v.id == key) : classes;
    let tempValue = [];

    if (key === '000') {
      tempValue = classes.map((item) => ({
        ...item,
        isChecked: !classes.filter((classItem) => classItem?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = classes.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setClasses(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedClassIds(ids);
    setClassName(
      ids.length === 0 || ids.length === classes.length
        ? 'All Classes'
        : tempValue
          .filter((item) => ids.includes(item.id))
          .map((item) => item.name)
          .join(', ')
    );
  };

  const handleTabSwitch = (tab) => {
    setClassName('All Classes');
    setStudentToIncludeTab(tab);
    if (tab == 2) {
      setSelectedClassIds([-1]);
      setSelectedClassId(-1);
      setSearchString('');
      getAssignmentStudentsAsync((reportType == 'single-admin-assessment' || !isAllReport) ? assignmentId : -1, 0, takeSize, true , []);
    }
    else if (tab == 0) {
      setSelectedClassIds([-1]);
      setSelectedClassId(-1);
    }
    else {
      if(classes.length === 0){
        getAssignmentClassesAsync((reportType == 'single-admin-assessment' || reportType == 'single-assignment' || !isAllReport) ? assignmentId : -1);
      }
      else{
        selectAllClasses(classes);
      }
    }
  };

  const loadMoreData = () => {
    if (!initial && hasMore) {
      const skipValue = skip + takeSize;
      getAssignmentStudentsAsync((reportType == 'single-admin-assessment' || reportType == 'single-assignment' || reportType == !isAllReport) ? assignmentId : -1, skipValue, takeSize, hasMore, students);
      setSkip(skipValue);
    }
  };

  const handleReportPage =()=>{
    if(studentToIncludeTab == 2 && selectedStudentId == 0){
      CustomToast('Please select a student to create report.','error');
      return;
    }
    if(isAllReport && studentToIncludeTab == 1 && selectedClassIds.length == 0){
      CustomToast('Please select at least one class to create report.','error');
      return;
    }
    handleCreateReport();
  };

  const handleBack = ()=>{
    setSelectedCourseId(-1);
    setStudentName('');
    window.history.back();
  };

  return (
    <>
      
      <div className='white-card'>
        <div className='align-items-center d-flex justify-content-between mb-4'>
          <h1 className='mb-4'>{title}</h1>
          <div>
            <button
              onClick={() => handleBack()}
              className="btn btn-castleWhite report-btn">
              Back
            </button>
          </div>
        </div>
        <p>{description}</p>
        {(isTOTReport || isAllReport) &&  <Row>
          <Col className='d-flex align-items-center'>
            <span className="flex-shrink-0">
              <i className="fa-duotone fa-circle-info fs-1 mr-2 clr-fa-circle-question"></i>
            </span>
            <div className="mb-0">Selecting all assignments and all classes can take a considerable amount of time to generate the report.</div>
          </Col>
        </Row>
        }
        {isPageLoading ?( 
          <SkeletonGrid
            rowCount={2}
            colCount={3}
            className={'mt-5 p-2'}/>
        ):(
          <>
            <Row className='mt-4'>
              <Col className='px-2'>
                <label className='mb-2'>Course</label>
                <DropDownSelect
                  value={courses}
                  selectedId={selectedCourseId}
                  setSelectedId={setSelectedCourseId}
                  dropdownId="courseList"
                  selectedName={courseName}
                  setSelectedName={setCourseName}
                />
              </Col>
              {!isTOTReport &&  <Col className='px-2'>
                <label className='mb-2'>Report Type</label>
                <input
                  className="form-control disable-Pointer-Events"
                  type='text'
                  value={type}
                  readOnly>
                </input>
              </Col>
              }
              {isTOTReport && 
            <Col className='px-2'>
              <label className='mb-2'>Report Type</label>
              <Row className="d-flex align-items-center blueTabs w-100 mx-0">
                <Col className={`w-50 justify-content-center btn ${!isAllReport ? 'active' : ''}`}
                  onClick={() => {setIsAllReport(false), 
                  getAssignmentStudentsAsync(assignmentId, 0, takeSize, true, []);
                  }}>Single Assignment/Assessment</Col>
                <Col className={`w-50 justify-content-center btn ${isAllReport ? 'active' : ''}`} 
                  onClick={() => {setIsAllReport(true), getAssignmentStudentsAsync(-1, 0, takeSize, true, []);
                  }}>All Assignments/Assessments</Col>
              </Row>
            </Col>
              }

              {isAllReport &&
            <Col className='px-2'>
              <Row>
                <Col>
                  <label className='mb-2'>From</label>
                  <div className='date-picker-input p-0'>
                    <DatePicker
                      selected={startDate}
                      onChange={(e) => setStartDate(e)}
                      dateFormat={'MM-dd-yyyy'}
                      className='form-control'
                    />
                  </div>
                </Col>
                <Col>
                  <label className='mb-2'>To</label>
                  <div className='date-picker-input p-0'>
                    <DatePicker
                      selected={endDate}
                      onChange={(e) => setEndDate(e)}
                      dateFormat={'MM-dd-yyyy'}
                      className='form-control'
                    />
                  </div>
                </Col>
              </Row>
            </Col>
              }
              {(reportType == 'single-admin-assessment' || reportType == 'single-assignment' || (isTOTReport && !isAllReport)) &&
            <Col className='px-2'>
              <label className='mb-2'>{isAssessment ? 'Assessment' : 'Assignment'} {isTOTReport?'/Assessment':''}</label>
              <DropDownSelect
                value={assignments}
                selectedId={assignmentId}
                setSelectedId={setAssignmentId}
                dropdownId="assignmentList"
                selectedName={selectedAssignmentName}
                setSelectedName={setSelectedAssignmentName}
              />
            </Col>}
            </Row>
            <Row className='mt-4'>
              {(reportType == 'all-admin-assessments' || reportType == 'all-assignments') &&
            <Col className='col-4 px-2'>
              <Row>
                <Col>
                  <label className='mb-2'>Score Type</label>
                </Col>
              </Row>
              <Row className="d-flex align-items-center blueTabs w-100 mx-0">
                <Col className={`justify-content-center btn ${scoreTypeTab == 0 ? 'active' : ''}`} onClick={() => setScoreTypeTab(0)}>Score</Col>
                <Col className={`justify-content-center btn ${scoreTypeTab == 1 ? 'active' : ''}`} onClick={() => setScoreTypeTab(1)}>Cumulative</Col>
              </Row>
            </Col>
              }
              {isTOTReport &&
            <Col className='col-4 px-2'>
              <Row>
                <Col>
                  <label className='mb-2'>Include retakes in report</label>
                </Col>
              </Row>
              <Row className="d-flex align-items-center blueTabs w-100 mx-0">
                <Col className={`justify-content-center btn ${!includeRetakes ? 'active' : ''}`} onClick={() => setIncludeRetakes(false)}>No</Col>
                <Col className={`justify-content-center btn ${includeRetakes ? 'active' : ''}`} onClick={() => setIncludeRetakes(true)}>Yes</Col>
              </Row>
            </Col>
              }
              <Col className='col-4 px-2'>
                <label className='mb-2'>Students To Include</label>
                <Row className="d-flex align-items-center blueTabs w-100 mx-0">
                  <Col className={`justify-content-center btn ${studentToIncludeTab == 2 ? 'active' : ''}`} onClick={() => handleTabSwitch(2)}>Single Student</Col>
                  <Col className={`justify-content-center btn ${studentToIncludeTab == 0 ? 'active' : ''}`} onClick={() => handleTabSwitch(0)}>All Students</Col>
                  <Col className={`justify-content-center btn ${studentToIncludeTab == 1 ? 'active' : ''}`} onClick={() => handleTabSwitch(1)}>Students in Class</Col>
                </Row>
              </Col>
              {studentToIncludeTab == 2 &&
            <Col className='col-4 px-2'>
              <label className='mb-2'>Student</label>
              <DropDownScroll
                key={dateBasedKey}
                value={students}
                selectedId={selectedStudentId}
                setSelectedId={setSelectedStudentId}
                dropdownId="studentList"
                selectedName={studentName}
                setSelectedName={setStudentName}
                loadMoreData={loadMoreData}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setSearchString={setDebouncedSearchText}
              />
            </Col>
              }
              {studentToIncludeTab == 1 &&
            <Col className='col-4 px-2'>
              <label className='mb-2'>Class</label>
              {isAllReport ? (
                <DropDownSearch
                  value={classes}
                  setValue={setClasses}
                  dropdownId="classList"
                  placeholder="Select Class"
                  handleChange={handleClassSelectionChange}
                  selectedId={selectedClassIds}
                  description={true}
                  selectAllText="All Classes"
                />
              ):(
                <DropDownSelect
                  value={classes}
                  selectedId={selectedClassId}
                  setSelectedId={setSelectedClassId}
                  dropdownId="courseList"
                  selectedName={className}
                  setSelectedName={setClassName}
                />
              )}
            </Col>
              }
            </Row>
          </>
        )}
        <div className='w-100 d-flex gap-3 mt-4'>
          <div className='w-100'></div>
          <button className="w-10 btn btn-castleRed" onClick={()=>handleReportPage()}>
            Create Report
          </button>
        </div>
      </div>
    </>
  );
};

ReportFilter.propTypes = {
  reportType: PropTypes.string,
  handleCreateReport: PropTypes.func,
  isTOTReport: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string
};
export default ReportFilter;
